import landing from './landing';
import main from './main';

const all = {
	...landing,
	...main
};

export default all;
